import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import moment from "moment";
export class CreditCard extends Model { 

    static get validationModel() {

        return {
            type: {
                label: 'CREDIT_CARD_TYPE'
            }
        };
    }
    
    setExpirationDate(date) {

        const dateObj = new moment(date);

        this.exp_month = dateObj.format('MM');

        this.exp_year = dateObj.format('YYYY');

        return date;
    }

}
AccessorsMutatorsDecorator('id','credit_card_type_id', 
'reservation_id','reservation', 'type', 'status', 'cardholder_name', 'pan', 'expiration_date', 'cvv', 'exp_month', 'exp_year')(CreditCard);


// WEBPACK FOOTER //
// ./src/pms-api/models/credit-card.model.js